import { Grid } from "@mui/material";
import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RadioGroup from "@mui/material/RadioGroup";
import RadioButton from "../../../../../library/custom/radioButton/RadioButton";
import FormControl from "@mui/material/FormControl";
import SelectMenu from "../../../../../library/custom/selectMenu/SelectMenu";
import PreviousOpenItems from "./previousOpenItems";
import { InputField } from "../../../../../library/custom/textBox/InputField";
import TextEditor from "../../../../../library/custom/textEditor/TextEditor";
import commonImages from "../../../../../assets";
import { useThemeContext } from "../../../../../context";
import Loader from "../../../../../library/common/Loader";
import FormLabels from "../../../../../library/custom/formLabel/FormLabels";
import Buttons from "../../../../../library/custom/button/Button";
import ImagePreview from "../../../../../library/imagePreview/imagePreview";

/* ================= FIX ================= */
const isQuestionAnswered = (q) => {
  if (Number(q.responseType) === 2) {
    return Boolean(q.textValueQuestion?.trim());
  }
  return (
    q.radioSelectiovalue !== undefined &&
    q.radioSelectiovalue !== null &&
    q.radioSelectiovalue !== ""
  );
};

const NOT_ACCEPTABLE_ERROR =
  "Change the answer to Acceptable or N/A, or add a corrective item for Not Acceptable questions.";

const hasStandaloneError = (sub) =>
  sub?.listInspectionQuestionAnswer?.some(
    (q) => q.standaloneNotAcceptableError,
  );

const hasUnansweredError = (sub) =>
  sub?.subCatError &&
  sub.listInspectionQuestionAnswer?.some((item) =>
    parseInt(item?.responseType) === 2
      ? !item.textValueQuestion
      : !item.radioSelectiovalue,
  );

const CategoryAccordion = (props) => {
  const { mode } = useThemeContext();
  const [accordionLoader, setaccordionLoader] = useState(false);
  const [allExpanded, setallExpanded] = useState(false);
  const [expandedItems, setExpandedItems] = useState([]);
  const [collapsedCategories, setCollapsedCategories] = useState([]);

  function handleAccordionExpand(value) {
    setExpandedItems((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
    );
  }
  props?.propsData?.swQuestionSetDetail?.forEach((category) => {
    let inspectedSubCount = 0;

    category?.listInspectionSubCategory?.forEach((subcategory) => {
      const total = subcategory.listInspectionQuestionAnswer?.length || 0;

      const answered =
        subcategory.listInspectionQuestionAnswer?.filter(isQuestionAnswered)
          ?.length || 0;

      subcategory.howManySub = answered;
      subcategory.subPercent = total ? (answered / total) * 100 : 0;

      if (answered > 0) inspectedSubCount += 1;
    });

    category.howManyCat = inspectedSubCount;
    category.catPercent = category.listInspectionSubCategory?.length
      ? (inspectedSubCount / category.listInspectionSubCategory.length) * 100
      : 0;
  });

  return (
    <>
      <Grid container justifyContent={"right"}>
        <Buttons
          varientContained={true}
          label={allExpanded ? "Collapse All" : "Expand All"}
          onClick={() => {
            setaccordionLoader(true);
            setallExpanded(!allExpanded);
            setTimeout(() => setaccordionLoader(false), 300);
          }}
        />
      </Grid>

      {accordionLoader ? (
        <Loader />
      ) : (
        <Grid mt={5}>
          <div>
            {props?.propsData?.swQuestionSetDetail?.map(
              (category, categoryIndex) => (
                <React.Fragment key={categoryIndex}>
                  <Accordion
                    className="swAccordianParent"
                    defaultExpanded
                    onChange={(e, isExpanded) =>
                      setCollapsedCategories((prev) =>
                        isExpanded
                          ? prev.filter((v) => v !== categoryIndex)
                          : [...prev, categoryIndex],
                      )
                    }
                  >
                    <AccordionSummary
                      className="swAccordian"
                      expandIcon={<ExpandMoreIcon />}
                    >
                      <div className="cateTitleWIns">
                        <Typography className="accoTitle">
                          {category.value}
                        </Typography>

                        <div className="catButtonBox">
                          <div className="cats">
                            {props?.propsData?.previousItem?.some((prevItem) =>
                              category?.listInspectionSubCategory?.some(
                                (subCategory) =>
                                  subCategory.listInspectionQuestionAnswer?.some(
                                    (item) =>
                                      props?.propsData?.previousItem.some(
                                        (secItem) =>
                                          parseInt(prevItem.questionId) ===
                                            parseInt(item.key) ||
                                          parseInt(secItem.questionId) ===
                                            parseInt(item.key),
                                      ),
                                  ),
                              ),
                            ) && (
                              <div className="openInfoContainer">
                                <div className="openInfoInfo">
                                  <img src={commonImages?.RedInfo} alt="" />
                                  <div className="openInfoMsg">
                                    There are some Open items in categories
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="inspectPersantage">
                            {category.howManyCat}/
                            {category.listInspectionSubCategory?.length}{" "}
                            Inspected ({category.catPercent?.toFixed(2)}%)
                          </div>
                        </div>
                      </div>
                    </AccordionSummary>

                    <AccordionDetails>
                      {category.listInspectionSubCategory.map(
                        (subcategory, subcategoryIndex) => (
                          <React.Fragment key={subcategoryIndex}>
                            <Accordion
                              className="swAccordianChild"
                              defaultExpanded={allExpanded}
                              onChange={() =>
                                handleAccordionExpand(subcategory.value)
                              }
                              expanded={
                                expandedItems.includes(subcategory.value) ||
                                allExpanded
                              }
                            >
                              <AccordionSummary
                                className="swChildAccordian"
                                expandIcon={<ExpandMoreIcon />}
                              >
                                <div className="subCatButton">
                                  <Typography className="accoTitle">
                                    {subcategory.value}
                                  </Typography>
                                  <div className="subCatButtonBox">
                                    <div>
                                      {props?.propsData?.previousItem?.some(
                                        (prevItem) =>
                                          subcategory?.listInspectionQuestionAnswer?.some(
                                            (item) =>
                                              prevItem.questionId === item.key,
                                          ),
                                      ) ? (
                                        <div className="openInfoContainer">
                                          <div className="openInfoInfo">
                                            <img
                                              src={commonImages?.RedInfo}
                                              alt=""
                                            />
                                            <div className="openInfoMsg">
                                              There are some Open items in
                                              sub-categories
                                            </div>
                                          </div>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    <div className="inspectPersantage">
                                      {subcategory.howManySub}/
                                      {
                                        subcategory.listInspectionQuestionAnswer
                                          .length
                                      }{" "}
                                      Inspected (
                                      {subcategory.subPercent?.toFixed(2)}%)
                                    </div>
                                  </div>
                                </div>

                                {subcategory?.listInspectionQuestionAnswer?.some(
                                  (x) => x.isTextResponse,
                                ) ||
                                props?.propsData?.previousItem?.some(
                                  (prevItem) =>
                                    subcategory?.listInspectionQuestionAnswer?.some(
                                      (item) =>
                                        prevItem.questionId === item.key,
                                    ),
                                ) ? (
                                  ""
                                ) : (
                                  <div className="posChange">
                                    {(subcategory?.showBth && allExpanded) ||
                                    (subcategory?.showBth &&
                                      expandedItems.includes(
                                        subcategory.value,
                                      )) ? (
                                      <div className="subCatButtonBox">
                                        <div
                                          className="allacceptbleBtn"
                                          onClick={(e) =>
                                            props?.propsData?.handleRadioType(
                                              null,
                                              null,
                                              subcategory,
                                              category,
                                              "allAcceptable",
                                              e,
                                            )
                                          }
                                        >
                                          All Acceptable
                                        </div>

                                        <div
                                          className="allNotapplicableBtn"
                                          onClick={(e) =>
                                            props?.propsData?.handleRadioType(
                                              null,
                                              null,
                                              subcategory,
                                              category,
                                              "notApplicable",
                                              e,
                                            )
                                          }
                                        >
                                          All N/A
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                )}
                              </AccordionSummary>

                              <AccordionDetails>
                                <ul>
                                  {subcategory.listInspectionQuestionAnswer.map(
                                    (question, questionIndex) => (
                                      <React.Fragment key={questionIndex}>
                                        <li className="accordianQuestionBox">
                                          <div className="quesTitle">
                                            {question.quesNo}. {question.value}
                                          </div>

                                          {question?.responseType === 2 ? (
                                            <div className="questionFreeText">
                                              <TextEditor
                                                value={
                                                  question?.textValueQuestion
                                                }
                                                placeholder={"Enter Here..."}
                                                name="freeText"
                                                onChange={(e) =>
                                                  props?.propsData?.handleRadioType(
                                                    e,
                                                    question,
                                                    subcategory,
                                                    category,
                                                    "questionV",
                                                  )
                                                }
                                              />
                                            </div>
                                          ) : (
                                            <>
                                              <div>
                                                <div className="radioContainer">
                                                  <RadioGroup
                                                    row
                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                    name="row-radio-buttons-group"
                                                    className="radioGroup"
                                                  >
                                                    <RadioButton
                                                      checked={
                                                        question.radioSelectiovalue ==
                                                        "1"
                                                      }
                                                      value={"1"}
                                                      label="Acceptable"
                                                      onChange={(e) =>
                                                        props?.propsData?.handleRadioType(
                                                          e.target.value,
                                                          question,
                                                          subcategory,
                                                          category,
                                                          "radio",
                                                        )
                                                      }
                                                      disabled={
                                                        props?.propsData
                                                          ?.previousItem
                                                          ?.length > 0 &&
                                                        props?.propsData?.previousItem?.some(
                                                          (x) =>
                                                            x.questionId ===
                                                              question.key &&
                                                            x.status === 2 &&
                                                            x.inspectionId !==
                                                              props?.propsData
                                                                ?.reportId,
                                                        )
                                                      }
                                                    />

                                                    <RadioButton
                                                      checked={
                                                        question.radioSelectiovalue ==
                                                        "2"
                                                      }
                                                      value={"2"}
                                                      label="Not Acceptable"
                                                      onChange={(e) =>
                                                        props?.propsData?.handleRadioType(
                                                          e.target.value,
                                                          question,
                                                          subcategory,
                                                          category,
                                                          "radio",
                                                        )
                                                      }
                                                    />

                                                    <RadioButton
                                                      checked={
                                                        question.radioSelectiovalue ==
                                                        3
                                                      }
                                                      value={3}
                                                      label="N/A"
                                                      onChange={(e) =>
                                                        props?.propsData?.handleRadioType(
                                                          e.target.value,
                                                          question,
                                                          subcategory,
                                                          category,
                                                          "radio",
                                                        )
                                                      }
                                                      disabled={
                                                        props?.propsData
                                                          ?.previousItem
                                                          ?.length > 0 &&
                                                        props?.propsData?.previousItem?.some(
                                                          (x) =>
                                                            x.questionId ===
                                                              question.key &&
                                                            x.status === 2 &&
                                                            x.inspectionId !==
                                                              props?.propsData
                                                                ?.reportId,
                                                        )
                                                      }
                                                    />
                                                  </RadioGroup>
                                                </div>

                                                {question.radioSelectiovalue ==
                                                "2" ? (
                                                  <>
                                                    {question.standaloneNotAcceptableError && (
                                                      <p
                                                        className="error"
                                                        style={{
                                                          marginLeft: "24px",
                                                        }}
                                                      >
                                                        Change the answer to
                                                        Acceptable or N/A, or
                                                        add a corrective item
                                                        for Not Acceptable
                                                        questions.
                                                      </p>
                                                    )}
                                                    {question.notAcceptableList
                                                      ?.length !== 0 &&
                                                      question.notAcceptableList?.map(
                                                        (
                                                          notAppce,
                                                          notAppceIndex,
                                                        ) => {
                                                          return (
                                                            <React.Fragment
                                                              key={
                                                                notAppceIndex
                                                              }
                                                            >
                                                              <Grid
                                                                container
                                                                className="itemContainer"
                                                              >
                                                                <Grid
                                                                  md={12}
                                                                  xs={12}
                                                                  item
                                                                  mt={1}
                                                                >
                                                                  <div
                                                                    onClick={() =>
                                                                      props?.propsData?.deleteform(
                                                                        notAppce?.id,
                                                                        question,
                                                                        subcategory,
                                                                        category,
                                                                        "deleteItem",
                                                                      )
                                                                    }
                                                                    className="removeRepetBox"
                                                                  >
                                                                    X Remove
                                                                    Items
                                                                  </div>

                                                                  <FormControl
                                                                    fullWidth
                                                                  >
                                                                    <FormLabels
                                                                      label="Item Found"
                                                                      isRequired={
                                                                        true
                                                                      }
                                                                    />
                                                                    <SelectMenu
                                                                      placeholder="Please Select"
                                                                      listData={
                                                                        question?.options ??
                                                                        []
                                                                      }
                                                                      value={
                                                                        notAppce?.itemFoundKey ??
                                                                        null
                                                                      }
                                                                      onchangehandler={(
                                                                        e,
                                                                      ) =>
                                                                        props?.propsData?.formchangeHnadle(
                                                                          e
                                                                            .target
                                                                            .value,
                                                                          question,
                                                                          subcategory,
                                                                          category,
                                                                          "itemFound",
                                                                          notAppce,
                                                                        )
                                                                      }
                                                                    />
                                                                  </FormControl>
                                                                  {notAppce?.itemFoundError && (
                                                                    <div className="error">
                                                                      Please
                                                                      select
                                                                      this
                                                                      required
                                                                      field.
                                                                    </div>
                                                                  )}
                                                                </Grid>

                                                                {notAppce?.itemFoundValue ===
                                                                  "Other" && (
                                                                  <Grid
                                                                    md={12}
                                                                    xs={12}
                                                                    item
                                                                    mt={2}
                                                                  >
                                                                    <FormLabels label="Item Details" />
                                                                    <TextEditor
                                                                      value={
                                                                        notAppce?.itemDetails
                                                                      }
                                                                      placeholder={
                                                                        "Enter Here..."
                                                                      }
                                                                      name="freeText"
                                                                      onChange={(
                                                                        e,
                                                                      ) =>
                                                                        props?.propsData?.formchangeHnadle(
                                                                          e,
                                                                          question,
                                                                          subcategory,
                                                                          category,
                                                                          "textArea",
                                                                          notAppce,
                                                                        )
                                                                      }
                                                                    />
                                                                  </Grid>
                                                                )}

                                                                <Grid
                                                                  md={12}
                                                                  xs={12}
                                                                  item
                                                                  mt={2}
                                                                >
                                                                  <div className="locationContainer">
                                                                    <FormControl
                                                                      fullWidth
                                                                    >
                                                                      <FormLabels
                                                                        label="Add Location Details"
                                                                        isRequired={
                                                                          true
                                                                        }
                                                                      />
                                                                    </FormControl>

                                                                    <div className="locationInput">
                                                                      <Grid
                                                                        container
                                                                        className="locationInputBox"
                                                                      >
                                                                        <Grid
                                                                          md={5}
                                                                          xs={
                                                                            12
                                                                          }
                                                                          item
                                                                        >
                                                                          <FormControl
                                                                            fullWidth
                                                                            className="mediaInputContainer"
                                                                          >
                                                                            <InputField
                                                                              fullWidth={
                                                                                true
                                                                              }
                                                                              type="text"
                                                                              value={
                                                                                notAppce?.addLocationText
                                                                              }
                                                                              onChange={(
                                                                                e,
                                                                              ) =>
                                                                                props?.propsData?.formchangeHnadle(
                                                                                  e
                                                                                    .target
                                                                                    .value,
                                                                                  question,
                                                                                  subcategory,
                                                                                  category,
                                                                                  "textFiled",
                                                                                  notAppce,
                                                                                )
                                                                              }
                                                                              placeholder={
                                                                                "Enter Text Here..."
                                                                              }
                                                                              className="locationInputText"
                                                                            />
                                                                          </FormControl>
                                                                        </Grid>

                                                                        <Grid
                                                                          md={5}
                                                                          xs={
                                                                            12
                                                                          }
                                                                          item
                                                                          className="addLocationCustomButton"
                                                                        >
                                                                          <Buttons
                                                                            aria-describedby="dd"
                                                                            variant="contained"
                                                                            type="button"
                                                                            name="btn"
                                                                            label={
                                                                              "Add Location"
                                                                            }
                                                                            onClick={(
                                                                              e,
                                                                            ) =>
                                                                              props?.propsData?.formchangeHnadle(
                                                                                e
                                                                                  .target
                                                                                  .value,
                                                                                question,
                                                                                subcategory,
                                                                                category,
                                                                                "pushData",
                                                                                notAppce,
                                                                              )
                                                                            }
                                                                            id="btnAddEquipment"
                                                                            varientAddIconBlue={
                                                                              true
                                                                            }
                                                                          />
                                                                        </Grid>
                                                                      </Grid>
                                                                    </div>

                                                                    {notAppce?.addLocatioList?.map(
                                                                      (
                                                                        noteee,
                                                                        noteeeIndex,
                                                                      ) => {
                                                                        const keyForInput =
                                                                          noteee?.id ??
                                                                          `noteee-${noteeeIndex}`;
                                                                        return (
                                                                          <Grid
                                                                            container
                                                                            key={
                                                                              noteee?.id ??
                                                                              noteeeIndex
                                                                            }
                                                                          >
                                                                            <Grid
                                                                              md={
                                                                                7
                                                                              }
                                                                              xs={
                                                                                12
                                                                              }
                                                                              item
                                                                            >
                                                                              <div className="locationListBox">
                                                                                <div className="locationList">
                                                                                  {noteee.textVaue ? (
                                                                                    <>
                                                                                      <div className="locationTitile">
                                                                                        <span>
                                                                                          {
                                                                                            noteee.textVaue
                                                                                          }
                                                                                        </span>
                                                                                        <div
                                                                                          className="removeImg"
                                                                                          onClick={() =>
                                                                                            props?.propsData?.deleteHandler(
                                                                                              category,
                                                                                              subcategory,
                                                                                              question,
                                                                                              notAppce,
                                                                                              noteee,
                                                                                              "deleteText",
                                                                                            )
                                                                                          }
                                                                                        >
                                                                                          x
                                                                                        </div>
                                                                                      </div>

                                                                                      {noteee?.imgUrl && (
                                                                                        <div className="locationImg">
                                                                                          <ImagePreview
                                                                                            src={
                                                                                              noteee?.imgUrl
                                                                                            }
                                                                                            className="showUploadedImg"
                                                                                          />

                                                                                          <div
                                                                                            className="removeImg"
                                                                                            onClick={() =>
                                                                                              props?.propsData?.deleteHandler(
                                                                                                category,
                                                                                                subcategory,
                                                                                                question,
                                                                                                notAppce,
                                                                                                noteee,
                                                                                                "deleteImg",
                                                                                              )
                                                                                            }
                                                                                          >
                                                                                            x
                                                                                          </div>
                                                                                        </div>
                                                                                      )}

                                                                                      {props
                                                                                        ?.propsData
                                                                                        ?.isMediaAllowed &&
                                                                                        !noteee?.imgUrl && (
                                                                                          <div className="addMedia">
                                                                                            {/* Hidden file input: store consistently on props.propsData.hiddenAttendeeSignatureInput */}
                                                                                            <input
                                                                                              type="file"
                                                                                              ref={(
                                                                                                el,
                                                                                              ) => {
                                                                                                const hidRef =
                                                                                                  props
                                                                                                    ?.propsData
                                                                                                    ?.hiddenAttendeeSignatureInput;
                                                                                                if (
                                                                                                  hidRef
                                                                                                ) {
                                                                                                  if (
                                                                                                    !hidRef.current
                                                                                                  )
                                                                                                    hidRef.current =
                                                                                                      {};
                                                                                                  hidRef.current[
                                                                                                    keyForInput
                                                                                                  ] =
                                                                                                    el;
                                                                                                }
                                                                                              }}
                                                                                              onChange={(
                                                                                                event,
                                                                                              ) => {
                                                                                                props?.propsData?.addMediaNotAccUpload(
                                                                                                  event,
                                                                                                  question,
                                                                                                  subcategory,
                                                                                                  category,
                                                                                                  notAppce,
                                                                                                  noteee,
                                                                                                );
                                                                                              }}
                                                                                              style={{
                                                                                                display:
                                                                                                  "none",
                                                                                              }}
                                                                                              accept="image/*"
                                                                                            />

                                                                                            <div
                                                                                              className="multipleIconContainer"
                                                                                              onClick={() => {
                                                                                                const inputEl =
                                                                                                  props
                                                                                                    ?.propsData
                                                                                                    ?.hiddenAttendeeSignatureInput
                                                                                                    ?.current?.[
                                                                                                    keyForInput
                                                                                                  ];
                                                                                                if (
                                                                                                  inputEl
                                                                                                ) {
                                                                                                  inputEl.click();
                                                                                                }
                                                                                              }}
                                                                                            >
                                                                                              <div className="multipleIconImg">
                                                                                                <img
                                                                                                  src={
                                                                                                    mode ===
                                                                                                    "dark"
                                                                                                      ? commonImages.multipleMediaDark
                                                                                                      : commonImages?.multipleMedia
                                                                                                  }
                                                                                                  alt="icon"
                                                                                                />
                                                                                              </div>
                                                                                              <div>
                                                                                                Upload
                                                                                                Media
                                                                                              </div>
                                                                                            </div>
                                                                                          </div>
                                                                                        )}
                                                                                    </>
                                                                                  ) : null}
                                                                                </div>

                                                                                {noteee?.uniqeFileErrorMessage &&
                                                                                  !noteee?.imgUrl && (
                                                                                    <Grid
                                                                                      className="error"
                                                                                      mt={
                                                                                        1
                                                                                      }
                                                                                    >
                                                                                      {
                                                                                        props
                                                                                          ?.propsData
                                                                                          ?.fileError
                                                                                      }
                                                                                    </Grid>
                                                                                  )}
                                                                              </div>
                                                                            </Grid>
                                                                          </Grid>
                                                                        );
                                                                      },
                                                                    )}
                                                                  </div>
                                                                  {notAppce?.addLocationDetailError && (
                                                                    <div className="error">
                                                                      Please
                                                                      select
                                                                      this
                                                                      required
                                                                      field.
                                                                    </div>
                                                                  )}
                                                                </Grid>
                                                              </Grid>
                                                            </React.Fragment>
                                                          );
                                                        },
                                                      )}

                                                    <Grid className="buttonConttainer">
                                                      <Buttons
                                                        aria-describedby="dd"
                                                        variant="variantOutlineBorder"
                                                        type="button"
                                                        name="btn"
                                                        label={"Add Item"}
                                                        id="btnAddEquipment"
                                                        variantOutlineBorder={
                                                          true
                                                        }
                                                        onClick={(e) =>
                                                          props?.propsData?.handleRadioType(
                                                            null,
                                                            question,
                                                            subcategory,
                                                            category,
                                                            "appendFrom",
                                                          )
                                                        }
                                                      />
                                                    </Grid>
                                                  </>
                                                ) : null}
                                              </div>
                                            </>
                                          )}
                                        </li>

                                        <PreviousOpenItems
                                          openItemHandler={
                                            props?.propsData?.openItemHandler
                                          }
                                          previousItem={
                                            props?.propsData?.previousItem
                                              ? props?.propsData?.previousItem?.filter(
                                                  (x) =>
                                                    x.questionId ===
                                                      question.key &&
                                                    x.inspectionId !==
                                                      props?.propsData
                                                        ?.reportId,
                                                )
                                              : []
                                          }
                                          getSwReference={
                                            props?.propsData?.getSwReference
                                          }
                                        />
                                      </React.Fragment>
                                    ),
                                  )}
                                </ul>
                              </AccordionDetails>
                            </Accordion>
                            {hasUnansweredError(subcategory) ? (
                              <p className="error mb-10">
                                All Question are required.
                              </p>
                            ) : null}
                            {!(
                              expandedItems.includes(subcategory.value) ||
                              allExpanded
                            ) && hasStandaloneError(subcategory) ? (
                              <p className="error mb-10">
                                {NOT_ACCEPTABLE_ERROR}
                              </p>
                            ) : null}
                          </React.Fragment>
                        ),
                      )}
                    </AccordionDetails>
                  </Accordion>
                  {collapsedCategories.includes(categoryIndex) ? (
                    <>
                      {category.listInspectionSubCategory?.some(
                        hasUnansweredError,
                      ) ? (
                        <p className="error mb-10">
                          All Question are required.
                        </p>
                      ) : null}
                      {category.listInspectionSubCategory?.some(
                        hasStandaloneError,
                      ) ? (
                        <p className="error mb-10">{NOT_ACCEPTABLE_ERROR}</p>
                      ) : null}
                    </>
                  ) : null}
                </React.Fragment>
              ),
            )}
          </div>
        </Grid>
      )}
    </>
  );
};

export default CategoryAccordion;
